import { ActivityType, Issue } from '../types/constants';
import { FlagAction } from '../types/tag';
import { Badge } from '../types/tag';

export const issues: Issue[] = [
  { id: 1, slug: 'double', title: 'دوبله' },
  { id: 2, slug: 'rotoscope', title: 'روتوسکوپی' },
  { id: 4, slug: 'loadSubtitle', title: 'خواندن زیرنویس' },
  { id: 3, slug: 'subtitle', title: 'زیرنویس' },
  { id: 5, slug: 'audioVideo', title: 'مشکلات فنی صدا و تصویر' },
  { id: 6, slug: 'force', title: 'مشکل حاد' },
];

export const flagsTranslate = {
  subtitle: 'زیرنویس',
  double: 'دوبله',
  force: 'فورس',
  force2: 'فورس2',
  force3: 'فورس3',
  normal: 'نرمال',
  ignore: 'بیخیال',
  return: 'برگشت به لیست',
  archive: 'اصلاحیه آرشیو',
};

export const flagsColor = {
  subtitle: '#f1c40f',
  double: '#37CDBE',
  force: '#e74c3c',
  force2: '#e74c3c',
  force3: '#e74c3c',
  normal: '#570DF8',
  ignore: '#1F2937',
  return: '#000',
  archive: '#00FFFF',
};

export const flags: FlagAction[] = [
  {
    name: 'فورس',
    slug: 'force',
    color: 'btn-error',
    badgeColor: 'badge-error',
  },
  {
    name: 'فورس2',
    slug: 'force2',
    color: 'btn-error',
    badgeColor: 'badge-error',
  },
  {
    name: 'فورس3',
    slug: 'force3',
    color: 'btn-error',
    badgeColor: 'badge-error',
  },
  {
    name: 'زیرنویس',
    slug: 'subtitle',
    color: 'btn-warning',
    badgeColor: 'badge-warning',
  },
  {
    name: 'دوبله',
    slug: 'double',
    color: 'btn-accent',
    badgeColor: 'badge-accent',
  },
  {
    name: 'نرمال',
    slug: 'normal',
    color: 'btn-primary',
    badgeColor: 'badge-primary',
  },
  {
    name: 'اصلاحیه آرشیو',
    slug: 'archive',
    color: 'btn-primary',
    badgeColor: 'badge-primary',
  },
  { name: 'بیخیال', slug: 'ignore', color: '', badgeColor: '' },
];

export const badgeColor: Badge = {
  force: 'badge-error',
  force2: 'badge-error',
  force3: 'badge-error',
  subtitle: 'badge-warning',
  double: 'badge-accent',
  normal: 'badge-primary',
  archive: 'badge-primary',
  ignore: '',
};

export const activityType: ActivityType = {
  'cart-creation': 'کارت <span class="badge badge-ghost badge-lg">__userstoryTitle__</span> ایجاد شد',
  'cart-assign':
    'کارت <span class="badge badge-ghost badge-lg">__userstoryTitle__</span> به <span class="badge badge-ghost badge-lg">__username__</span> اساین شد',
  'task-creation': 'مورد <span class="badge badge-ghost badge-lg">__taskTitle__</span> ایجاد شد',
  'qc-done': 'کارت <span class="badge badge-ghost badge-lg">__userstoryTitle__</span> به اتمام رسید',
  'task-done': 'مورد <span class="badge badge-ghost badge-lg">__taskTitle__</span> انجام شد',
  'change-user-story-status':
    'وضعیت کارت <span class="badge badge-ghost badge-lg">__userstoryTitle__</span> از حالت <span class="badge badge-ghost badge-lg">__oldStatus__</span> به حالت <span class="badge badge-ghost badge-lg">__newStatus__</span> تغییر داده شد',
  'change-task-status':
    'وضعیت مورد <span class="badge badge-ghost badge-lg">__taskTitle__</span> از حالت <span class="badge badge-ghost badge-lg">__oldStatus__</span> به حالت <span class="badge badge-ghost badge-lg">__newStatus__</span> تغییر داده شد',
};

export const activityTranslate = {
  'cart-creation': 'ایجاد کارت',
  'cart-assign': 'اساین کردن',
  'task-creation': 'ایجاد مورد',
  'qc-done': 'اتمام کارت',
  'task-done': 'اتمام مورد',
  'change-user-story-status': 'تغییر وضعیت کارت',
  'change-task-status': 'تغییر وضعیت مورد',
};

export const adminEmails = [
  'ali.naseri07@gmail.com', // Ali Naseri
  'amiramir@admin.com', // Amir Zandieh
  'amirzandieh01@gmail.com', // Amir Zandieh
  'amirzandieh1@gmail.com', // Amir Zandieh
  'remakhdomi@gmail.com',
  'cs.jazei@gmail.com', // Saeed Jazi

  'amin0nurse@gmail.com', // Amin
  'shahabfilimo79@gmail.com', // Shahab
  'manzar.cid2007@gmail.com', // Manzar
  'hamed.hasanpoor@gmail.com', // Hamed Hasanpour
  'elahefarazmand@gmail.com', // Elahe
  'far.atlasi@gmail.co', // Faranak
  'far.atlasi@gmail.com', // Faranak
  'mrzmahsa2@gmail.com', // Mahsa Mirzaei
  'seyed.alireza.miryazdi@gmail.com', // Alireza Miryazdi
  'aminshajareh32@gmail.com', // Amin Shajareh
  'farinaz.mokhtari@gmail.com',
];
